// extracted by mini-css-extract-plugin
export var calendarView = "_nb-0";